import * as React from 'react';
import * as Swipeable from 'react-swipeable';
import { throttle } from 'lodash';
import Arrow from 'src/components/common/Arrow';

import './Carousel.scss';

interface ICarouselProps {
  children: any;
}

interface ICarouselState {
  currentIndex: number;
  translateValue: number;
  enableRightArrow: boolean;
  enableLeftArrow: boolean;
  itemsToShow: number;
  showArrows: boolean;
}

export class Carousel extends React.Component<ICarouselProps, ICarouselState> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentIndex: 0,
      translateValue: 0,
      enableRightArrow: true,
      enableLeftArrow: false,
      showArrows: true,
      itemsToShow: 6
    };
  }

  private showRightArrowBasedOnItemsNumber = (): boolean => {
    return this.state.itemsToShow >= React.Children.count(this.props.children)
      ? false
      : true;
  };

  private getItemsNumber = (): number => {
    return this.state.itemsToShow >= React.Children.count(this.props.children)
      ? React.Children.count(this.props.children)
      : this.state.itemsToShow;
  };

  private getSlotHeight = (): number => {
    return this.getItemsNumber() > 1 ? 11 : 100;
  };

  private previousSlide = (): void => {
    const lastIndex = React.Children.count(this.props.children) - 1;
    const { currentIndex } = this.state;
    const shouldResetIndex = currentIndex === 0;
    const index = shouldResetIndex ? lastIndex : currentIndex - 1;

    this.setState((prevState: any) => ({
      currentIndex: index,
      translateValue: prevState.translateValue + this.getSlotHeight(),
      enableRightArrow: true,
      enableLeftArrow: index === 0 ? false : true
    }));
  };

  private nextSlide = (): void => {
    const lastIndex = React.Children.count(this.props.children) - 1;
    const { currentIndex } = this.state;
    const shouldResetIndex = currentIndex === lastIndex;
    const index = shouldResetIndex ? 0 : currentIndex + 1;

    this.setState((prevState: any) => ({
      currentIndex: index,
      translateValue: prevState.translateValue + -this.getSlotHeight(),
      enableRightArrow:
        index === lastIndex || index === lastIndex - this.getItemsNumber() + 1
          ? false
          : true,
      enableLeftArrow: true
    }));
  };

  private handleSwipe = throttle(
    (isNext: boolean) => {
      if (isNext) {
        if (
          this.state.enableRightArrow &&
          this.showRightArrowBasedOnItemsNumber()
        ) {
          this.nextSlide();
        }
      } else {
        if (this.state.enableLeftArrow) {
          this.previousSlide();
        }
      }
    },
    500,
    { trailing: false }
  );

  public render() {
    return (
      <Swipeable
        onSwipingLeft={() => this.handleSwipe(true)}
        onSwipingRight={() => this.handleSwipe(false)}
        trackMouse={true}
      >
        <div className="rp-part-carousel--wrapper">
          {this.state.showArrows && this.state.enableLeftArrow && (
            <Arrow
              iconName="rpds-expand-less"
              clickFunction={this.previousSlide}
            />
          )}

          <div className="rp-part-carousel--window">
            <div
              className="rp-part-carousel--container"
              style={{
                transform: `translateY(${this.state.translateValue}%)`,
                transition: 'transform ease-out 0.45s'
              }}
            >
              {React.Children.map(this.props.children, child => (
                <div
                  className="rp-part-carousel--slot"
                  style={{
                    flexBasis: `${this.getSlotHeight()}%`
                  }}
                >
                  {child}
                </div>
              ))}
            </div>
          </div>
          {this.state.showArrows &&
            this.showRightArrowBasedOnItemsNumber() &&
            this.state.enableRightArrow && (
              <Arrow
                iconName="rpds-expand-more"
                clickFunction={this.nextSlide}
              />
            )}
        </div>
      </Swipeable>
    );
  }
}

export default Carousel;
